<template>
    <form-container headerText="Spielergebnis eingeben" :width="480" action="editSpielKoResult"
                    :valid-actions="['editSpielKoResult']" @save="save()">
        <div v-if="spiel" class="pa-5">
            <table style="width: 100%; vertical-align: top">
                <tr class="primary--text font-weight-bold">
                    <td class="labelCol"></td>
                    <td class="pr-2 teamCol">{{spiel.team1?.settings.name}}</td>
                    <td class="pl-2 teamCol">{{spiel.team2?.settings.name}}</td>
                </tr>
                <tr v-for="(satz, i) in spiel?.getSaetzeList()" :key="i">
                    <td colspan="3">
                        <table style="vertical-align: top">
                            <tr>
                                <td class="primary--text font-weight-bold pr-3 labelCol">
                                    <span>{{1 + (bewerb.runden[currentData.rundenId]?.settings.spiel.wuerfeProSatz * i)}}</span>
                                    <span>-</span>
                                    <span>{{bewerb.runden[currentData.rundenId]?.settings.spiel.wuerfeProSatz * (i+1)}}</span>
                                </td>
                                <td class="pr-2 teamCol">
                                    <v-text-field v-model="satz.k1" clearable type="number"
                                                  :rules="notRequired?[]:[rules.requiredPosNumber]"/>
                                </td>
                                <td class="pl-2 teamCol">
                                    <v-text-field v-model="satz.k2" clearable type="number"
                                                  :rules="notRequired?[]:[rules.requiredPosNumber]"/>
                                </td>
                            </tr>
                            <tr v-if="satz.suddenVictoryRequired()">
                                <td class="labelCol"/>
                                <td class="pr-2 teamCol">
                                    <v-text-field v-model="satz.sv1" clearable type="number" label="Sudden victory"
                                                  :rules="notRequired?[]:[rules.requiredPosNumber]"/>
                                </td>
                                <td class="pr-2 teamCol">
                                    <v-text-field v-model="satz.sv2" clearable type="number" label="Sudden victory"
                                                  :rules="notRequired?[]:[rules.requiredPosNumber]"/>
                                </td>
                            </tr>
                            <tr v-if="satz.suddenVictoryIsTied()" class="error--text" style="font-size: 12px">
                                <td class="labelCol"/>
                                <td colspan="2" class="pr-2">
                                    Beim Sudden Victory müssen die geworfenen Kegel der beiden Teams unterschiedlich sein.
                                </td>
                            </tr>
                        </table>
                    </td>
                </tr>
                <tr v-if="spiel?.getSpielResult(bewerb.settings.spiel).showSpielSV">
                    <td class="primary--text font-weight-bold pt-5">Spiel</td>
                    <td class="pr-2">
                        <v-text-field v-model="spiel.sv1" label="Sudden victory" clearable type="number"
                                      :rules="notRequired?[]:[rules.requiredPosNumber]"/>
                    </td>
                    <td class="pl-2">
                        <v-text-field v-model="spiel.sv2" label="Sudden victory" clearable type="number"
                                      :rules="notRequired?[]:[rules.requiredPosNumber]"/>
                    </td>
                </tr>
                <tr v-if="spiel?.suddenVictoryIsTied()"class="error--text" style="font-size: 12px">
                    <td class="labelCol"/>
                    <td colspan="2">
                        Beim Sudden Victory müssen die geworfenen Kegel der beiden Teams unterschiedlich sein.
                    </td>
                </tr>
                <tr>
                    <td class="primary--text font-weight-bold pt-5"></td>
                    <td class="pr-2">
                        <v-select v-model="spiel.team1Status" :items="resultStatus"
                                  item-text="label" item-value="value"
                                  label="Status" :rules="[rules.required]"/>
                    </td>
                    <td class="pl-2">
                        <v-select v-model="spiel.team2Status" :items="resultStatus"
                                  item-text="label" item-value="value"
                                  label="Status" :rules="[rules.required]"/>
                    </td>
                </tr>
                <tr>
                    <td class="primary--text font-weight-bold pt-5"></td>
                    <td colspan="2">
                        <v-text-field v-model="spiel.kommentar" label="Kommentar zum Spiel" clearable/>
                    </td>
                </tr>
            </table>
        </div>
    </form-container>
</template>

<script>
import FormContainer from "@/components/form/formContainer.vue";
import {FormRules} from "@/services/formRules";
import {BewerbSpiel} from "@/services/data/meisterschaften/bewerbSpiel";
import {RESULT_STATUS} from "@/services/data/meisterschaften/bewerb_constants";

export default {
    name: "spielKoResultEdit",
    components: {FormContainer},
    props: ['currentData', 'bewerb'],
    computed: {
        editParam(){ return this.$route.query.action === 'editSpielKoResult' },
        notRequired(){ return this.spiel.team1Status !== 'finished' || this.spiel.team2Status !== 'finished'}
    },
    data: () => ({
        rules: null,
        spiel: null,
        error: '',
        resultStatus: RESULT_STATUS
    }),
    created(){
        this.rules = new FormRules();
    },
    methods: {
        init(){
            this.spiel = new BewerbSpiel(this.currentData, null,
                                  Object.keys(this.currentData.saetze).length)
        },
        async save(){
            const spielResult = this.spiel.getSpielResult(this.bewerb.settings.spiel)
            if ( !spielResult.winnerTeam ) return
            this.$store.state.local.loader = true;
            const dataObject = this.spiel.getResultUpdateObject(
                'runden.' + this.currentData.rundenId + '.spiele.' + this.currentData.id, spielResult.winnerTeam
            )
            const reply = await this.bewerb.update(dataObject);
            reply.successful ? this.handleSuccess(reply) : this.error = reply.content
            this.$store.state.local.loader = false;
        },
        handleSuccess(reply){
            console.log ("reply", reply);
            this.bewerb.runden[this.currentData.rundenId].spiele[this.currentData.id] = this.spiel
            this.spiel = null;
            window.history.back();
        },
    },
    watch: {
        editParam(to){ if ( to ) this.init() },
        spiel: {
            handler(){
                this.spiel?.cleanSuddenVictory(this.bewerb.settings.spiel)
            },
            deep: true
        },
    }
}
</script>

<style scoped>
    .labelCol{width: 16%;}
    .teamCol{width: 42%;}
</style>